module.exports = __webpack_public_path__ + "static/media/qq_face.41e6461a.png";